import {EFilterForm, Filter} from '@shared/models/filter.model';
import {Utilities as U} from '@shared/utilities/utilities.model';
import { EDossierWorkingDashboardStatus } from './enums.model';
import { EWorkingStates } from './dossier-working.model';

export enum EDossierWorkingFilterForm {
	working_number_prefix = 'working_number_prefix',
	practice_id 					= 'claim_practice_id', 
	po 										= 'po',
	commodity_name        = 'commodity_name',    			// nome centro assistenza
	customer_trading_name = 'customer_trading_name',  // ragione sociale cliente
	user_group 						= 'user_group',  	     			// gruppo canalizzazione
	username 					   	= 'username',			     			// utente canalizzazione
	statuses 							= 'statuses',
	company 							= 'company',
	ald_commodity_id 			= 'ald_commodity_id',
	working_type 					= 'type',
	causal 								= 'causal_type',
	created_at_from 			= 'created_at_from',
	created_at_to 				= 'created_at_to',
	plate 							  = 'plate',

	// filtri dalla dashboard
	grouped_status 				= 'grouped_status',
	exclude_status 				= 'exclude_status',
	status 				 			  = 'status',
	
	// performance e archiviazione
	// serve solo per la ricerca delle pratiche attive
	to_archive 				 		= 'to_archive',
}

export class DossierWorkingFilterModel extends Filter {

	[EDossierWorkingFilterForm.working_number_prefix] : string;
	[EDossierWorkingFilterForm.commodity_name]			  : string;
	[EDossierWorkingFilterForm.customer_trading_name]	: string;
	[EDossierWorkingFilterForm.practice_id]					  : string;
	[EDossierWorkingFilterForm.po]										: string;
	[EDossierWorkingFilterForm.user_group]						: string;
	[EDossierWorkingFilterForm.username]				  		: string;
	[EDossierWorkingFilterForm.statuses]							: EWorkingStates[];
	[EDossierWorkingFilterForm.company]							  : string;
	[EDossierWorkingFilterForm.ald_commodity_id]			: string;
	[EDossierWorkingFilterForm.working_type]					: string;
	[EDossierWorkingFilterForm.causal]								: string;
	[EDossierWorkingFilterForm.created_at_from]			  : Date;
	[EDossierWorkingFilterForm.created_at_to]				  : Date;
	[EDossierWorkingFilterForm.plate]				 		      : Date;
	[EDossierWorkingFilterForm.grouped_status]				: EDossierWorkingDashboardStatus | EWorkingStates;
	[EDossierWorkingFilterForm.exclude_status]				: EDossierWorkingDashboardStatus | EWorkingStates;
	[EDossierWorkingFilterForm.status]	 			  			: EDossierWorkingDashboardStatus | EWorkingStates;
	[EDossierWorkingFilterForm.to_archive]	 			  	: boolean;

	constructor(model?: any) {
		super();

		if (U.isEmpty(model)) {
			return;
		}

		this[EFilterForm.order_by]	= U.nullish(model[EFilterForm.order_by], null);
		
		// dev'essere preso in considerazione il valore false
		this[EFilterForm.asc]	      = !U.isVoid(model[EFilterForm.asc]) ? model[EFilterForm.asc] : null;
		
		this[EFilterForm.page_size]	= U.nullish(model[EFilterForm.page_size], null);
		this[EFilterForm.page]	    = U.nullish(model[EFilterForm.page], null);
		
		this[EDossierWorkingFilterForm.working_number_prefix]	= model[EDossierWorkingFilterForm.working_number_prefix];
		this[EDossierWorkingFilterForm.commodity_name] 				= model[EDossierWorkingFilterForm.commodity_name];
		this[EDossierWorkingFilterForm.customer_trading_name] = model[EDossierWorkingFilterForm.customer_trading_name];
		this[EDossierWorkingFilterForm.practice_id]						= model[EDossierWorkingFilterForm.practice_id];
		this[EDossierWorkingFilterForm.po]										= model[EDossierWorkingFilterForm.po];
		this[EDossierWorkingFilterForm.user_group]						= model[EDossierWorkingFilterForm.user_group];
		this[EDossierWorkingFilterForm.username]							= model[EDossierWorkingFilterForm.username];
		this[EDossierWorkingFilterForm.statuses]							= model[EDossierWorkingFilterForm.statuses];
		this[EDossierWorkingFilterForm.company]								= model[EDossierWorkingFilterForm.company];
		this[EDossierWorkingFilterForm.ald_commodity_id]			= model[EDossierWorkingFilterForm.ald_commodity_id];
		this[EDossierWorkingFilterForm.working_type]					= model[EDossierWorkingFilterForm.working_type];
		this[EDossierWorkingFilterForm.causal]								= model[EDossierWorkingFilterForm.causal];
		this[EDossierWorkingFilterForm.created_at_from]				= model[EDossierWorkingFilterForm.created_at_from];
		this[EDossierWorkingFilterForm.created_at_to]					= model[EDossierWorkingFilterForm.created_at_to];
		this[EDossierWorkingFilterForm.plate]			  					= model[EDossierWorkingFilterForm.plate];
		this[EDossierWorkingFilterForm.grouped_status]				= model[EDossierWorkingFilterForm.grouped_status];
		this[EDossierWorkingFilterForm.exclude_status]				= model[EDossierWorkingFilterForm.exclude_status];
		this[EDossierWorkingFilterForm.status]			  				= model[EDossierWorkingFilterForm.status];
		this[EDossierWorkingFilterForm.to_archive]						= model[EDossierWorkingFilterForm.to_archive];
	}

	clone(): DossierWorkingFilterModel {
		const clone: DossierWorkingFilterModel = new DossierWorkingFilterModel();
		
		clone[EFilterForm.order_by]	 = U.nullish(this[EFilterForm.order_by], null);
		
		// dev'essere preso in considerazione il valore false
		clone[EFilterForm.asc]	     = !U.isVoid(this[EFilterForm.asc]) ? this[EFilterForm.asc] : null;

		clone[EFilterForm.page_size] = U.nullish(this[EFilterForm.page_size], null);
		clone[EFilterForm.page]	   	 = U.nullish(this[EFilterForm.page], null);
		
		clone[EDossierWorkingFilterForm.working_number_prefix] = this[EDossierWorkingFilterForm.working_number_prefix];
		clone[EDossierWorkingFilterForm.commodity_name] 			 = this[EDossierWorkingFilterForm.commodity_name];
		clone[EDossierWorkingFilterForm.customer_trading_name] = this[EDossierWorkingFilterForm.customer_trading_name];
		clone[EDossierWorkingFilterForm.practice_id]					 = this[EDossierWorkingFilterForm.practice_id];
		clone[EDossierWorkingFilterForm.po]										 = this[EDossierWorkingFilterForm.po];
		clone[EDossierWorkingFilterForm.user_group]						 = this[EDossierWorkingFilterForm.user_group];
		clone[EDossierWorkingFilterForm.username]							 = this[EDossierWorkingFilterForm.username];
		clone[EDossierWorkingFilterForm.statuses]							 = this[EDossierWorkingFilterForm.statuses];
		clone[EDossierWorkingFilterForm.company]							 = this[EDossierWorkingFilterForm.company];
		clone[EDossierWorkingFilterForm.ald_commodity_id]			 = this[EDossierWorkingFilterForm.ald_commodity_id];
		clone[EDossierWorkingFilterForm.working_type]					 = this[EDossierWorkingFilterForm.working_type];
		clone[EDossierWorkingFilterForm.causal]								 = this[EDossierWorkingFilterForm.causal];
		clone[EDossierWorkingFilterForm.created_at_from]			 = this[EDossierWorkingFilterForm.created_at_from];
		clone[EDossierWorkingFilterForm.created_at_to]				 = this[EDossierWorkingFilterForm.created_at_to];
		clone[EDossierWorkingFilterForm.plate]			  				 = this[EDossierWorkingFilterForm.plate];
		clone[EDossierWorkingFilterForm.grouped_status]				 = this[EDossierWorkingFilterForm.grouped_status];
		clone[EDossierWorkingFilterForm.exclude_status]				 = this[EDossierWorkingFilterForm.exclude_status];
		clone[EDossierWorkingFilterForm.status]			  				 = this[EDossierWorkingFilterForm.status];
		clone[EDossierWorkingFilterForm.to_archive]						 = this[EDossierWorkingFilterForm.to_archive];

		return clone;
	}

	getFilterUrl(): string {
		return U.getQuery(this);
	}

	newFilter(model?: any): DossierWorkingFilterModel {
		return new DossierWorkingFilterModel(model);
	}
}
